import { en } from "./en";

export type TranslationKey = keyof typeof en;
export type TranslationVars = Record<string, string | number>;

/**
 * §B7.6: every user-visible string is a dotted key in `en.ts`; interpolation is `{n}` placeholders.
 * A missing key returns the key itself — visible in a test and in a screenshot, never a blank.
 */
export function t(key: TranslationKey, vars?: TranslationVars): string {
  const template: string | undefined = en[key];
  if (template === undefined) {
    return key;
  }
  if (vars === undefined) {
    return template;
  }
  return template.replace(/\{(\w+)\}/g, (match, name: string) => {
    const value = vars[name];
    return value === undefined ? match : String(value);
  });
}

/**
 * The escape hatch for the documented dynamic key families (`state.*`, `severity.*`, `support.*`, …). It is typed
 * as `string` on purpose: `tests/i18n.test.ts` exempts these prefixes from the "every key is referenced" check and
 * enforces that every key they can produce exists.
 */
export function tDynamic(prefix: string, suffix: string, vars?: TranslationVars): string {
  return t(`${prefix}${suffix}` as TranslationKey, vars);
}
